export default {
  'auth.welcome': '欢迎回来',
  'auth.subtitle': '登录您的 NexChat 账户。您的消息是私密且安全的。',
  'auth.continue': '继续使用 NexChat',
  'app.name': 'NexChat',
  'app.loading': '加载中…',
  'app.online': '在线',
  'app.away': '离开',
  'app.busy': '忙碌',
  'app.appear_offline': '显示为离线',
  'sidebar.conversations': '您的对话',
  'sidebar.new_conversation': '新建对话',
  'sidebar.search': '搜索对话…',
  'sidebar.loading': '加载房间…',
  'sidebar.empty': '暂无对话。\n创建一个开始吧。',
  'sidebar.select': '从侧栏选择对话或开始新对话。',
  'chat.encrypted': '此对话已进行端对端加密',
  'chat.loading': '加载消息中…',
  'chat.no_messages': '暂无消息',
  'chat.be_first': '率先发送消息吧！',
  'chat.voice_call': '语音通话',
  'chat.video_call': '视频通话',
  'chat.pins': '置顶消息',
  'chat.starred': '星标消息',
  'chat.search': '搜索消息',
  'input.placeholder': '发送消息给 {room}…',
  'input.hint_send': '按 {enter} 发送 · {shift_enter} 换行',
  'input.poll': '创建投票',
  'input.gif': 'GIF 和贴纸',
  'input.attach': '附加文件',
  'input.schedule': '定时发送',
  'input.record': '按住或点击录音',
  'input.nexai': '询问 NexAI',
  'msg.reply': '回复',
  'msg.edit': '编辑',
  'msg.delete': '删除',
  'msg.copy': '复制',
  'msg.forward': '转发',
  'msg.pin': '置顶',
  'msg.unpin': '取消置顶',
  'msg.star': '星标',
  'msg.unstar': '取消星标',
  'msg.thread': '话题',
  'msg.translate': '翻译',
  'msg.react': '表情回应',
  'msg.edited': '已编辑',
  'msg.deleted': '此消息已被删除',
  'thread.title': '话题',
  'thread.replies': '回复',
  'thread.reply_placeholder': '在话题中回复…',
  'thread.hint': 'Enter 回复 · Shift+Enter 换行',
  'thread.summarise': '✨ 摘要',
  'thread.summarising': '⏳ 生成摘要中…',
  'thread.summary_title': '✨ AI 摘要',
  'thread.not_enough': '消息不足，无法生成摘要',
  'nexai.placeholder': '询问 NexAI…',
  'nexai.title': 'NexAI',
  'nexai.thinking': '思考中…',
  'nexai.clear': '清除',
  'search.title': '搜索消息',
  'search.placeholder': '搜索消息、联系人、关键词…',
  'search.empty': '输入开始搜索',
  'search.no_results': '无结果',
  'search.searching': '搜索中…',
  'search.results': '{count} 条结果',
  'profile.edit': '编辑资料',
  'profile.theme': '主题',
  'profile.scheduled': '定时消息',
  'profile.notifications': '通知设置',
  'profile.logout': '退出登录',
  'theme.title': '🎨 选择主题',
  'theme.subtitle': '12 款主题 — 深色和浅色变体。',
  'theme.close': '关闭',
  'notif.title': '通知设置',
  'notif.browser': '浏览器通知',
  'notif.browser_sub': '新消息到达时显示桌面提醒',
  'notif.sound': '声音通知',
  'notif.sound_sub': '新消息时播放声音',
  'notif.volume': '音量',
  'notif.push': '推送通知',
  'notif.push_sub': '即使 NexChat 关闭也能收到提醒',
  'notif.push_enabled': '✓ 已启用',
  'notif.push_enable': '启用推送',
  'notif.push_enabling': '启用中…',
  'notif.sounds_title': '自定义声音',
  'notif.preview': '▶ 预览',
  'notif.upload': '📎 上传',
  'notif.clear': '✕ 清除',
  'notif.new_message': '新消息',
  'notif.mention': '@ 提及',
  'notif.dm': '私信',
  'notif.ringtone': '来电铃声',
  'notif.save': '保存',
  'notif.close': '关闭',
  'room.new_title': '新建对话',
  'room.dm_tab': '💬 私信',
  'room.channel_tab': '# 频道',
  'room.dm_placeholder': '@用户名:nexchat.ethosserver.com',
  'room.channel_placeholder': '例如：general',
  'room.channel_label': '频道名称',
  'room.dm_label': '用户名',
  'room.start_dm': '开始对话',
  'room.create_channel': '创建频道',
  'room.cancel': '取消',
  'poll.create': '创建投票',
  'poll.question': '问题',
  'poll.question_placeholder': '提出一个问题…',
  'poll.option': '选项 {n}',
  'poll.add_option': '+ 添加选项',
  'poll.single': '单选',
  'poll.multi': '多选',
  'poll.anonymous': '匿名',
  'poll.submit': '创建投票',
  'poll.cancel': '取消',
  'poll.end': '结束投票',
  'poll.ended': '投票已结束',
  'poll.votes': '{n} 票',
  'btn.save': '保存',
  'btn.cancel': '取消',
  'btn.close': '关闭',
  'btn.send': '发送',
  'btn.delete': '删除',
  'btn.edit': '编辑',
  'btn.confirm': '确认',
  'toast.copied': '已复制到剪贴板',
  'toast.message_deleted': '消息已删除',
  'toast.profile_updated': '资料已更新',
  'toast.offline_queued': '离线 — 消息已排队，重新连接后发送',
  'toast.back_online': '已重新连接 — 已发送 {count} 条消息',
  'toast.scheduled': '已安排在 {time} 发送',
  'toast.poll_created': '投票已创建！',
};
